import React, { useState } from "react";
import "./inderx.scss";
import { Modal } from "antd";

export default function CardOpportunities(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const { data } = props;

  return (
    <div
      className="card_opportunities"
      onClick={() => {
        if (isModalOpen) return;
        setIsModalOpen(true);
      }}
    >
      <div>
        {/* <div className="title_tag">Position</div> */}
        <div className="title">{data?.position}</div>
      </div>

      <div className="infomation">
        <div className="item">
          {/* <div className='type'>Country</div> */}
          <div className="info">
            {data?.country}
            {"\u00A0"}
            {"\u00A0"}
            {"\u00A0"}
          </div>
        </div>
        <div className="item">
          {/* <div className='type'>City</div> */}
          <div className="info">{data?.Place}</div>
        </div>
      </div>
      <span className="readmore">
        <span></span>
      </span>
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        width={720}
      >
        <div className="content">
          <div>
            <div className="title">{data?.position}</div>
          </div>

          <div className="infomation">
            {data?.country && (
              <div className="item">
                <div className="type">Country</div>
                <div className="info">{data?.country}</div>
              </div>
            )}
            {data?.Place && (
              <div className="item">
                <div className="type">City</div>
                <div className="info">{data?.Place}</div>
              </div>
            )}
          </div>
          <div className="info2">
            <div
              className="info2_text"
              dangerouslySetInnerHTML={{ __html: data?.Requirements }}
            ></div>

            <div
              className="info2_text"
              dangerouslySetInnerHTML={{ __html: data?.Responsibility }}
            ></div>
          </div>

          <div className="info3">
            <div className="info3_title">HR Email:</div>
            <div className="hr_contact">
              {data?.HRemail ? (
                <a href={`mailto:${data.HRemail}`}>{data.HRemail}</a>
              ) : (
                <span>hr@linktel.com; campus@linktel.com</span>
              )}
            </div>
            {data?.link && (
              <div className="to_website">
                <a href={data.link} target="_blank" rel="noreferrer">
                  或者您可以在三方招聘平台上传简历 {">"}
                </a>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}
